import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("gpc_cookie_consent")) setShow(true);
  }, []);
  const accept = (val) => { localStorage.setItem("gpc_cookie_consent", val); setShow(false); };
  if (!show) return null;
  return (
    <div data-testid="cookie-consent" className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="max-w-4xl mx-auto glass-nav-dark text-white rounded-2xl p-5 shadow-2xl border border-white/10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="text-gold shrink-0" />
        <p className="text-sm text-slate-200 flex-1">We use privacy-friendly cookies to improve your experience and understand how our site is used. See our <Link to="/legal/cookie-policy" className="text-gold underline">Cookie Policy</Link>.</p>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => accept("essential")} className="px-4 py-2 rounded-full text-sm font-semibold border border-white/30 hover:bg-white/10">Essential only</button>
          <button onClick={() => accept("all")} className="px-4 py-2 rounded-full text-sm font-bold btn-gold">Accept all</button>
        </div>
      </div>
    </div>
  );
}
